import React from "react";
import PropTypes from "prop-types";
import { Label, Col } from "reactstrap";
import ImageInput from "./ImageInput";

/*
    This is a component that returns an image input field along with its label, preview and the option to delete the picture.
*/
class ImageField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  handleValidatedFileChange(id, image) {
    const { onFileChange } = this.props;
    onFileChange(id, image);
  }

  handleCheckboxChange(event) {
    event.persist();
    const { onDeleteChange } = this.props;
    onDeleteChange(event);
  }

  render() {
    const {
      id,
      required,
      label,
      width,
      height,
      dimensions,
      image
    } = this.props;
    const imagePreview = image ? (
      <img src={image} alt="" className="col-md-9" />
    ) : null;
    const deleteCheckbox =
      !required && image ? (
        <React.Fragment>
          <input
            type="checkbox"
            name={`delete_${id}`}
            onClick={this.handleCheckboxChange}
          />
          Delete
        </React.Fragment>
      ) : null;

    return (
      <React.Fragment>
        <Label for={id} sm={2}>
          {label}
        </Label>
        <Col>
          <ImageInput
            name={id}
            id={id}
            validate={this.handleValidatedFileChange}
            width={width}
            height={height}
            dimensions={dimensions}
            required={required && !image}
          />
        </Col>
        <Col>
          {imagePreview}
          {deleteCheckbox}
        </Col>
      </React.Fragment>
    );
  }
}
ImageField.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  image: PropTypes.string,
  onDeleteChange: PropTypes.func.isRequired,
  onFileChange: PropTypes.func.isRequired,
  required: PropTypes.bool
};
ImageField.defaultProps = {
  image: undefined,
  required: false,
  width: 0,
  height: 0
};
export default ImageField;



// WEBPACK FOOTER //
// ./src/views/components/ImageField.jsx